module.exports = __webpack_public_path__ + "img/img (29).a3140836.jpg";